import file from '../../common/file';
import formatDate from '../../assets/formatDate';
import formatBytes from '../../assets/formatBytes';
import MoreOptionsMenu from './MoreOptionsMenu';
import FileTitle from './FileTitle';
import { remove } from '../../api/File';
import { getAccessToken } from '../Auth';
import { useContext } from 'react';
import { FileSystemContext } from '../FileSystem';

interface Props {
  file: file;
  onDisplay: (file: file) => void;
  download: (file_uid: string, filename: string, size: number) => void;
  onMove: (id: string) => void;
  openPropertiesViewer: () => void;
}

const File: React.FC<Props> = ({
  file,
  onDisplay,
  download,
  onMove,
  openPropertiesViewer,
}) => {
  const { useFiles } = useContext(FileSystemContext);
  const [files, setFiles] = useFiles();
  const onDelete = async () => {
    remove(file.file_uid, await getAccessToken(), () => {
      setFiles((state) => state.filter((e) => e.file_uid !== file.file_uid));
    });
  };
  return (
    <tr>
      <td className="filename">
        <FileTitle file={file} onDisplay={onDisplay} download={download} />
      </td>
      <td>{formatBytes(parseInt(file.size))}</td>
      <td>{formatDate(file.last_updated)}</td>
      <td>
        <MoreOptionsMenu
          file={file}
          openPropertiesViewer={openPropertiesViewer}
          onMove={onMove}
          onDelete={onDelete}
        />
      </td>
    </tr>
  );
};

export default File;
